<template lang="pug">

    div

        .field(v-for="fieldSet in formModel.fieldSets")
            field-set-form(
                ref='forms'
                v-bind:field-set-model="fieldSet"
                v-model="fields"
            )


</template>

<script>
    import FieldSetForm from './variant-forms/FieldSetForm'

    //noinspection JSUnusedGlobalSymbols
    export default {

        components: { FieldSetForm },

        computed: {

            $invalid() {
                return this.$refs.forms.find(forms => forms.$invalid) !== undefined
            },

            fields: {
                get() { return this.value.fields },
                set(value) { this.$emit('input', { ...this.value,  fields: { ...value } }) }
            }
        },

        methods: {
            $touch() {
                this.$refs.forms.forEach(form => form.$touch())
            }
        },

        props: {

            formModel: {
                type: Object,
                required: true
            },

            value: {
                type: Object,
                required: true
            }

        }

    }

</script>
